import moment from 'moment'
import {Album} from '../types'

export const getScheduleText = (album: Album): string => {
  if (album.isDraft) return 'Draft'
  if (album.publishDate !== null && moment(album.publishDate).isAfter())
    return `Scheduled for ${moment(album.publishDate).format('L LT')}`
  return 'Published'
}
